export const INITIATIVE_CONTENT = {
  initiatives: 'Initiatives',
  initiative: 'Initiative',
  initiativeLabels: {
    title: 'Title of the Initiative',
    leader: 'Name of the Initiative Leader',
  },

  // reports
  initiativeDateRange: 'Initiative Date Range',
  initiativeImpacts: 'Initiative Impacts',
  initiativeImpact: 'Initiative Impact',
  initiativeType: 'Initiative Type',
  initiativeTypes: 'Initiative Types',
  initiativeCategories: 'Initiative Categories',
  initiativeCategory: 'Initiative Category',
  initiativeParticipantsAdded:
    'Initiative Participants Have Been Added or Edited.',

  initiativeCategoriesTooltip:
    'You can create your own titles of activities or channels to accurately represent and track the critical change management work product that is meaningful to you and your organization. These can be customized and are organized by communication, readiness, training, and sustainment. All titles you create are filterable and reportable.',

  initiativeChangeInsightAIEmptyTitle:
    'Create A Feedback Form For This Initiative!',
  initiativeChangeInsightAIEmptyTitleDescription:
    'Using surveys or assessments provides structured methods to gather data, measure progress, and gauge stakeholder sentiment throughout the change process. Want to send a survey or assessment for this initiative? Select a "ready-to-use" template from your organization\'s ChangeInsights Hub or build your own to meet the unique needs of your change effort.',

  initiativeChangeInsightEmptyTitle:
    'Send A Survey or Assessment For This Initiative!',
  initiativeChangeInsightEmptyDescription:
    'Using surveys or assessments provides structured methods to gather data, measure progress, and gauge stakeholder sentiment throughout the change process. Want to send a survey or assessment for this initiative? Select a "ready-to-use" template from your organization\'s ChangeInsights Hub or build your own to meet the unique needs of your change effort.',

  deleteFeedbackFormTemplate: 'Delete Feedback Form template',
  deleteFeedbackFormTemplateDescription:
    'Are you sure you want to delete template? Action cannot be undone. If the feedback form template was used in the Initiative, it won’t be affected.',

  deleteInitiativeCategory: 'Delete Initiative Category',
  deleteInitiativeCategoryDescription:
    'Are you sure you want to delete this initiative category? If it is used in Projects, it will remain available for the reporting purposes.',
};
